export type DropdownItem = {
  id: string;
  module: string;
  page: string;
  name: string;
  category: string;
  value: string;
  label: string;
  description: string | null;
  sortOrder: number;
  isActive: boolean;
  isSystem: boolean;
  parentCategory: string | null;
  parentValue: string | null;
  allowMultiple: boolean;
  metadata: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string;
};

export type CategoryMeta = {
  module: string;
  page: string;
  name: string;
  category: string;
  itemCount: number;
  isSystem: boolean;
  allowMultiple: boolean;
  parentCategory: string | null;
};

export type PageNode = {
  page: string;
  dropdowns: CategoryMeta[];
};

export type ModuleNode = {
  module: string;
  pages: PageNode[];
};

export type CategoryMetaFlat = {
  category: string;
  name: string;
  module: string;
  page: string;
  parentCategory: string | null;
  itemCount: number;
};

export type CreateCategoryPayload = {
  module: string;
  page: string;
  name: string;
  category: string;
  allowMultiple?: boolean;
  parentCategory?: string | null;
};

export type UpdateCategoryPayload = {
  name?: string;
  allowMultiple?: boolean;
  parentCategory?: string | null;
};

export type CreateItemPayload = {
  value: string;
  label: string;
  description?: string | null;
  sortOrder?: number;
  isActive?: boolean;
  parentCategory?: string | null;
  parentValue?: string | null;
  metadata?: Record<string, unknown> | null;
};

export type UpdateItemPayload = {
  value?: string;
  label?: string;
  description?: string | null;
  sortOrder?: number;
  isActive?: boolean;
  parentValue?: string | null;
  metadata?: Record<string, unknown> | null;
};

export function slugifyValue(label: string): string {
  return label
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}
